import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import styled from "styled-components";
import Loader from './Loader';

const StyledIframe = styled.iframe`
  min-height: 99%;
  min-width: 100%;
  border: none;
  overflow: auto;
`;

const handleIframeMessage = (event) => {
  if (event.origin === window.location.origin && event.data) {
    const { action } = event.data;

    if (['picked', 'cancel'].includes(action)) {
      setTimeout(() => {
        window.top.close();
        window.close()
        window.open('', '_self').close()
      }, 1000);
    }
  }
}

const PickerIframeWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    window.addEventListener('message', handleIframeMessage);

    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  return (<StyledIframe
    id="picker-iframe"
    src={`/picker${location.search}`}
  />);
};

export default PickerIframeWrapper;
